












import TimeRangeControls from "@/components/TimeRangeControls.vue";
import ProcessedStatsChart from "@/components/ProcessedStatsChart.vue";
import { getTitle } from "@/utils/chart";
import { Component, Vue } from "vue-property-decorator";

@Component({ components: { TimeRangeControls, ProcessedStatsChart } })
export default class OverviewChart extends Vue {
  chartTitle(chartID: string): string {
    return getTitle(chartID);
  }
}
